"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entrypoints = void 0;
// To move to `insurance.ts` when microservice are ready to go
exports.entrypoints = {
    publicSignup: '/policies/public-health',
};
